import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-push-row-block',
  templateUrl: './push-row-block.component.html',
})
export class PushRowBlockComponent {
  @Input() pushes!: any[];
}
